import { ScheduleProvider } from 'hooks/useSchedule';

import { AppointmentTermsProvider } from 'templates/Schedule/shared/hooks/useAppointmentTerms';

export const ScheduleLayout: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return (
    <AppointmentTermsProvider>
      <ScheduleProvider>{children}</ScheduleProvider>
    </AppointmentTermsProvider>
  );
};
